"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dhsInstallerComponent = exports.DhsInstallerComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var Forms_1 = require("Forms");
var SignUpUtils_1 = require("Views/Partials/Components/SignUp/services/SignUpUtils");
var SignUpFormConfig_1 = require("Views/Partials/Components/SignUp/SignUpFormConfig");
var formLoad_1 = require("./formLoad");
var InstallerFormConfig_1 = require("./InstallerFormConfig");
var DhsInstallerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DhsInstallerComponent, _super);
    function DhsInstallerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.dhs-installer-signup';
        _this.formWrapId = '#newsletter-form';
        _this.formFields = {
            firstName: 'firstName',
            lastName: 'lastName',
            company: 'company',
            companyType: 'companyType',
            numberOfEmployees: 'numberOfEmployees',
            jobFunction: 'function',
            email: 'email',
            country: 'country',
            language: 'language',
            postalZipCode: 'postalZipCode',
        };
        _this.renderLoader = function (popupAriaLabel, closeButtonAriaLabel) {
            (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Spinner, _this.wrapper, null, 'newsletter-form group', popupAriaLabel, closeButtonAriaLabel);
        };
        _this.renderMessage = function (title, message, buttonLabel) {
            (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Message(message, buttonLabel), _this.wrapper, title, 'newsletter-form newsletter-form--message group');
        };
        _this.setDefaults = function (inputs) {
            return inputs.map(function (input) {
                if (input.name === SignUpFormConfig_1.formControlKeys.companyType) {
                    return tslib_1.__assign(tslib_1.__assign({}, input), { defaultValue: InstallerFormConfig_1.defaults[SignUpFormConfig_1.formControlKeys.companyType] });
                }
                return input;
            });
        };
        return _this;
    }
    DhsInstallerComponent.prototype.OnInit = function () {
        var _this = this;
        this.wrapper = $(this.formWrapId).get(0);
        this.el.forEach(function (el) {
            _this.InitForm(el);
        });
    };
    DhsInstallerComponent.prototype.InitForm = function (el) {
        var _this = this;
        var apiUrl = app_1.AttrService.data(el, 'url');
        var pageId = app_1.AttrService.data(el, 'page');
        var control = app_1.AttrService.data(el, 'control');
        var locationApiUrl = app_1.AttrService.data(el, 'location-api-base-url');
        var locationApiKey = app_1.AttrService.data(el, 'location-api-key');
        var culture = app_1.AttrService.data(el, 'culture');
        var defaultErrorMsg = app_1.AttrService.data(el, 'error-message');
        var popupAriaLabel = app_1.AttrService.data(el, 'newsletter-aria-label');
        var closeButtonAriaLabel = app_1.AttrService.data(el, 'close-button-aria-label');
        var bypassRecaptchaKey = app_1.AttrService.data(el, 'bypass-recaptcha-key');
        var additionalFormData = {
            applications: app_1.AttrService.data(el, 'applications'),
            markets: app_1.AttrService.data(el, 'markets'),
            segments: app_1.AttrService.data(el, 'segments'),
            solutions: app_1.AttrService.data(el, 'solutions'),
            subSegments: app_1.AttrService.data(el, 'subSegments'),
        };
        var countryService = SignUpUtils_1.signUpUtils.createCountryService(locationApiUrl, culture, locationApiKey);
        el.querySelector('.cta').addEventListener('click', function (ev) {
            ev.preventDefault();
            // open modal && show preloader
            _this.renderLoader(popupAriaLabel, closeButtonAriaLabel);
            var formDataPromise = SignUpUtils_1.signUpUtils.getFormData(apiUrl, { pageId: pageId });
            var countryPromise = countryService.getDataForSelectOptions();
            var buttonLabel = $(ev.target).text().trim();
            var labels = {
                buttonLabel: buttonLabel,
                popupAriaLabel: popupAriaLabel,
                closeButtonAriaLabel: closeButtonAriaLabel,
            };
            Promise.all([formDataPromise, countryPromise])
                .then(function (_a) {
                var formData = _a[0], countries = _a[1];
                var languages = SignUpUtils_1.signUpUtils.convertLanguages(formData.languages);
                var formItems = _this.convertData(formData, countries, languages);
                var reCaptchaSiteKey = formData.reCaptchaSiteKey;
                _this.renderForm(formData, formItems, additionalFormData, reCaptchaSiteKey, bypassRecaptchaKey, control, labels, pageId);
            })
                .catch(function (err) {
                _this.renderMessage(null, err.response.data.message || defaultErrorMsg);
            });
        });
    };
    DhsInstallerComponent.prototype.convertData = function (model, countries, languages) {
        return {
            consentText: model.specificFields.userConsentText,
            consentValidationMessage: model.specificFields.userConsentValidationMessage,
            chineseConsentText: model.specificFields.userChineseConsentText,
            chineseConsentValidationMessage: model.specificFields.userChineseConsentValidationMessage,
            departments: [],
            countries: countries,
            companyTypes: (0, Forms_1.formatOptions)(model.companyTypes, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            numberOfEmployees: (0, Forms_1.formatOptions)(model.numberOfEmployees, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            explanationText: model.specificFields.explanationText,
            functions: (0, Forms_1.formatOptions)(model.functions, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            genericFields: model.genericFields,
            inputs: this.setDefaults(SignUpUtils_1.signUpUtils.formatInputs(this.formFields, model.genericFields, model.specificFields)),
            languages: SignUpUtils_1.signUpUtils.formatLanguages(languages),
            specificFields: model.specificFields,
            submitLabel: model.genericFields.submitLabel,
        };
    };
    DhsInstallerComponent.prototype.renderForm = function (formData, formItems, additionalFormData, reCaptchaSiteKey, bypassRecaptchaKey, control, labels, pageId) {
        var _this = this;
        var title = formData.specificFields && formData.specificFields.titleText
            ? formData.specificFields.titleText
            : null;
        var inputObject = this.getInputObject(formItems);
        var gtmData = {
            label: labels.buttonLabel,
            title: title,
            control: control,
        };
        app_1.GTM.newsletter.open(gtmData);
        var onModelClose = function () {
            app_1.GTM.newsletter.abandon(gtmData);
        };
        if (formData.culture) {
            additionalFormData.culture = formData.culture;
        }
        var renderSpinner = function () {
            _this.renderLoader(labels.popupAriaLabel, labels.closeButtonAriaLabel);
        };
        var render = {
            renderSpinner: renderSpinner,
            renderMessage: this.renderMessage,
        };
        var hashMapTypes = {
            additionalFormData: additionalFormData,
            formFields: this.formFields,
        };
        var signUpTypes = {
            formItems: formItems,
            inputObject: inputObject,
        };
        // render form instead loader
        (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Form(signUpTypes, formData.postUrl, reCaptchaSiteKey, bypassRecaptchaKey, render, hashMapTypes, control, pageId), this.wrapper, title, 'newsletter-form group', labels.popupAriaLabel, labels.closeButtonAriaLabel, onModelClose);
    };
    DhsInstallerComponent.prototype.getInputObject = function (_a) {
        var inputs = _a.inputs, countries = _a.countries, companyTypes = _a.companyTypes, numberOfEmployees = _a.numberOfEmployees, functions = _a.functions, genericFields = _a.genericFields, specificFields = _a.specificFields, languages = _a.languages;
        var inputObject = inputs.reduce(function (acc, currentValue) {
            acc[currentValue.name] = currentValue;
            return acc;
        }, {});
        inputObject.country.options = countries;
        inputObject.companyType.options = companyTypes;
        inputObject.numberOfEmployees.options = numberOfEmployees;
        inputObject.jobFunction.options = functions;
        inputObject.language.languages = languages;
        inputObject.genericFields = genericFields;
        inputObject.specificFields = specificFields;
        return inputObject;
    };
    return DhsInstallerComponent;
}(app_1.Component));
exports.DhsInstallerComponent = DhsInstallerComponent;
exports.dhsInstallerComponent = new DhsInstallerComponent();
